function Loading () {

    return (
        <section className="LoadingComponent">
            <div className="LoadingSpinner"></div>
        </section>
    )
}

export default Loading;